module.exports = __webpack_public_path__ + "static/media/admin_Ronald.853a7fd7.svg";